
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 12c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C16.27 14.45 15.46 13 14 13c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C6.44 19.74 5 20.55 5 22c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C16.73 20.55 17.54 22 19 22c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"}}),_c('path',{attrs:{"d":"M19 13l.94-2.07L22 10l-2.06-.93L19 7l-.92 2.07L16 10l2.08.93L19 13zM7.5 15l.5-2 2-.5-2-.5-.5-2-.5 2-2 .5 2 .5.5 2z"}})])
          )
        }
      }
    